export const hasFlag = (source, flag, sourceKey = 'Flags') => {
    return (source && (flag in source[sourceKey]));
};